import { forwardRef, HTMLAttributes } from "react";
import { cn } from "./utils";

const Table = forwardRef<HTMLTableElement, HTMLAttributes<HTMLTableElement>>(
  ({ className, ...props }, ref) => (
    <table
      ref={ref}
      className={cn("al-w-full al-caption-bottom al-text-sm", className)}
      {...props}
    />
  ),
);
Table.displayName = "Table";

export default Table;
